import { css } from "@emotion/css";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { mapOr } from "option-t/esm/PlainOption";
import React from "react";
import { PageContainer } from "../../components/PageContainer";
import { usePageview } from "../../services/Tracking/usePageview";
import { useStore } from "../../store";
import { filterEntriesByToday } from "../../utils";
import { formatDate } from "../../utils/date";

const HomePage = () => {
  const {
    state: { user, entries },
  } = useStore();

  usePageview("/");

  return (
    <PageContainer title="Home">
      <Grid container spacing={2}>
        {user.isAuthenticated && (
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title={
                  <Typography variant="subtitle2">
                    Today
                    <Typography
                      component="span"
                      variant="caption"
                      className={css`
                        margin-left: 8px;
                      `}
                    >
                      {mapOr(
                        formatDate(new Date().toISOString(), "EEEE, MMM dd"),
                        "N/A",
                        (date) => date,
                      )}
                    </Typography>
                  </Typography>
                }
              />
              <CardContent
                className={css`
                  padding-top: 0;
                `}
              >
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="h2">
                      <Box fontWeight="fontWeightBold">
                        {filterEntriesByToday(entries.data).length}
                      </Box>
                    </Typography>
                    <Typography variant="caption">Entries</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </PageContainer>
  );
};

export default HomePage;
